import { useContext } from "react";
import useSWR from "swr";
import { ToastContext } from "../context/ToastContext";
import { environment } from "../config/environment";
import { useSWRFetcher } from "./useSWRFetcher";
import { ActivityModel } from "@attelas/shared";

export const useReceivablesComments = (externalId?: string | null) => {
  const fetcher = useSWRFetcher();
  const { showToast } = useContext(ToastContext);

  const { data, isLoading, error, mutate } = useSWR<{
    comments: ActivityModel[];
  }>(
    externalId ? `${environment.apiUrl}/api/receivables/${externalId}/comments` : null,
    (url: string) => fetcher(url),
    {
      onError: () => {
        showToast("Failed to get the comments, please try again later", "error");
      },
    }
  );

  return {
    comments: data?.comments || [],
    isLoading,
    isError: !!error,
    refetchComments: () => mutate(),
  };
};
